<script setup lang="ts">
import { modalsRegistered, modalRemove, type ModalItem } from '@/services/modals';
import { computed } from 'vue';

const modalsRendering = computed(() => {
  return modalsRegistered.value.filter((m) => m.component);
});

const modalsOpened = new Set<ModalItem['modalID']>();

function refHandler(modal: ModalItem, r: any) {
  if (!modalsOpened.has(modal.modalID) && r?.modal?.open) {
    modalsOpened.add(modal.modalID);
    r.modal
      .open()
      .then(modal.component!.resolve)
      .finally(() => {
        modalRemove(modal.modalID);
        modalsOpened.delete(modal.modalID);
      });
  }
}
</script>

<template>
  <div v-for="modal of modalsRendering" :key="modal.modalID">
    <component
      :is="modal.component!.content"
      :modalID="modal.modalID"
      v-bind="modal.component!.bindings"
      :ref="(ref: any) => refHandler(modal, ref)"
    ></component>
  </div>
</template>
